import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ChannelHintBox from "@/components/Member/ChannelHintBox";
import { MemberPageHeader } from "@/components/Member/MemberPageHeader";
import { MemberPageLayout } from "@/components/Member/MemberPageLayout";
import SignUpBenefit from "@/components/Member/SignUpBenefit";
import useKakaoSignInUp from "@/components/Member/hooks/useKakaoSignInUp";
import Icon from "@/components/icon/Icon";
import { ArrowRight, Sizes, ThunderboltIcon } from "@/components/icon/IconList";
import { SignIn } from "@/components/signIn/SignInComponents";
import useRedirect from "@/hooks/useRedirect";
import { useApiService } from "@/lib/apiService";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { LOGIN_PAGE } from "@/settings/constant";
import { ConfirmDialog } from "@bookips/sds";
import { Button } from "@bookips/solvook-ui-library";
import { Typography, styled as muiStyled, useTheme } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useEffect } from "react";
import LoginDialog from "src/store/loginDialog";
import { getNiceToken } from "../../../api/nice";
import { getParams, toQueryString } from "../../../utils/misc";
import { ButtonInTypography, InnerBox } from "../login";
const SignUpNextPage = ()=>{
    const router = useRouter();
    const theme = useTheme();
    const { isDesktop  } = useWindowDimensions();
    const apiService = useApiService();
    const { redirectAgain  } = useRedirect();
    const { onKakao  } = useKakaoSignInUp();
    const { isOpenSignUpDialog , openSignUpDialogContents , setState  } = LoginDialog((state)=>({
            isOpenSignUpDialog: state.isOpenSignUpDialog,
            openSignUpDialogContents: state.openSignUpDialogContents,
            setState: state.setState
        })) //회원가입, 로그인시 다이얼로그 store
    ;
    const { data: niceQuery  } = useQuery([
        "niceQuery"
    ], ()=>getNiceToken({
            returnUrl: "".concat(window.location.origin, "/signup/")
        }), {
        staleTime: Infinity
    });
    const onPhone = async ()=>{
        localStorage.setItem("reqKey", niceQuery.reqKey);
        const nicePopup = window.open(undefined, "nicePopup", "width=430, height=700, scrollbars=no, resizable=no");
        if (!apiService) {
            return;
        }
        try {
            nicePopup === null || nicePopup === void 0 ? void 0 : nicePopup.document.write('\n					<html>\n						<body>\n							<form name="form" id="form" action="https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb">\n								<input type="hidden" id="m" name="m" value="service" />\n								<input type="hidden" id="token_version_id" name="token_version_id" value="'.concat(niceQuery.tokenVersionId, '" />\n								<input type="hidden" id="enc_data" name="enc_data" value="').concat(niceQuery.encrypted, '"/>\n								<input type="hidden" id="integrity_value" name="integrity_value" value="').concat(niceQuery.integrityCheck, '" />\n							</form>\n						</body>\n						<script>\n							document.form.submit();\n						</script>\n					</html>\n					'));
        } catch (error) {
            ;
        }
        //mix-119
        mixpanelEvent("Sign Up Started", {
            "Button Name": "휴대폰 번호로 가입하기"
        });
    };
    useEffect(()=>{
        if (!router.query.enc_data) return;
        const id = router.query.token_version_id;
        const data = router.query.enc_data;
        self.close();
        const params = getParams(window.opener.location.search);
        const query = toQueryString({
            ...params,
            tokenVersionId: id,
            encData: data,
            next: router.query.next
        });
        window.opener.location.href = "".concat(window.location.origin, "/signup/form/").concat(query);
    }, [
        router.query
    ]);
    return /*#__PURE__*/ _jsxs(SignUpNextPageWrapper, {
        children: [
            !isDesktop ? /*#__PURE__*/ _jsx(MemberPageHeader, {
                pageTitle: "회원가입",
                showBackButton: true
            }) : /*#__PURE__*/ _jsx(MemberPageHeader, {
                showLogo: true
            }),
            /*#__PURE__*/ _jsxs(SignUpContent, {
                children: [
                    isDesktop && /*#__PURE__*/ _jsx(SignUpBenefit, {}),
                    /*#__PURE__*/ _jsxs(SignIn, {
                        children: [
                            !isDesktop ? /*#__PURE__*/ _jsx(SignUpBenefit, {}) : /*#__PURE__*/ _jsx(Typography, {
                                variant: "bold28",
                                sx: {
                                    textAlign: "center"
                                },
                                children: "회원가입"
                            }),
                            /*#__PURE__*/ _jsxs(InnerBox, {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "sing-in-btn-box",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Tooltip, {
                                                children: [
                                                    /*#__PURE__*/ _jsx(Icon, {
                                                        icon: ThunderboltIcon,
                                                        size: Sizes.small
                                                    }),
                                                    /*#__PURE__*/ _jsx(Typography, {
                                                        variant: "bold12",
                                                        sx: {
                                                            display: "block"
                                                        },
                                                        children: "3초만에 가입 가능!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(SignIn.KakaoButton, {
                                                type: "SIGNUP",
                                                onKakao: onKakao
                                            }),
                                            /*#__PURE__*/ _jsx(SignIn.PhoneButton, {
                                                type: "SIGNUP",
                                                onPhone: onPhone
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(ButtonInTypography, {
                                        variant: "regular14",
                                        color: theme.palette.text.secondary,
                                        sx: {
                                            gap: "8px"
                                        },
                                        children: [
                                            "이미 쏠북 회원이신가요?",
                                            /*#__PURE__*/ _jsx(Button, {
                                                variant: "strokeSecondary",
                                                className: "sign-up-btn",
                                                label: /*#__PURE__*/ _jsxs(ButtonInTypography, {
                                                    variant: "semibold14",
                                                    color: theme.palette.text.secondary,
                                                    sx: {
                                                        gap: "4px"
                                                    },
                                                    onClick: ()=>{
                                                        //mix-120 회원가입 페이지에서 로그인 버튼 클릭시
                                                        mixpanelEvent("Login Button Clicked");
                                                        redirectAgain("".concat(LOGIN_PAGE));
                                                    },
                                                    children: [
                                                        "로그인",
                                                        /*#__PURE__*/ _jsx(Icon, {
                                                            icon: ArrowRight,
                                                            size: Sizes.smallHalf,
                                                            color: theme.palette.text.secondary
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ConfirmDialog, {
                open: isOpenSignUpDialog,
                onOpenChange: (open)=>{
                    if (!open) setState("isOpenSignUpDialog", false);
                },
                severity: openSignUpDialogContents.severity === "success" ? "success" : openSignUpDialogContents.severity === "caution" ? "default" : "error",
                title: openSignUpDialogContents.title,
                description: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        openSignUpDialogContents.content,
                        /*#__PURE__*/ _jsx(ChannelHintBox, {
                            maskedPhone: openSignUpDialogContents.maskedPhone,
                            maskedEmail: openSignUpDialogContents.maskedEmail
                        })
                    ]
                }),
                confirmText: openSignUpDialogContents.btnLabel || "확인",
                onConfirm: ()=>{
                    var _openSignUpDialogContents_onOk;
                    (_openSignUpDialogContents_onOk = openSignUpDialogContents.onOk) === null || _openSignUpDialogContents_onOk === void 0 ? void 0 : _openSignUpDialogContents_onOk.call(openSignUpDialogContents);
                    setState("isOpenSignUpDialog", false);
                }
            })
        ]
    });
};
SignUpNextPage.getLayout = (page)=>{
    return /*#__PURE__*/ _jsx(MemberPageLayout, {
        children: page
    });
};
const SignUpNextPageWrapper = muiStyled("div")(()=>({
        width: "100%",
        height: "100%",
        minHeight: "752px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    }));
const SignUpContent = muiStyled("article")(()=>({
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        gap: "40px",
        div: {
            height: "auto"
        }
    }));
// 회원가입 완료 페이지에서 사용될 수 있는 tooltip
export const Tooltip = muiStyled("p")((param)=>{
    let { theme  } = param;
    return {
        position: "absolute",
        display: "flex",
        top: "-14px",
        left: "12px",
        backgroundColor: theme.palette.text.title,
        color: theme.palette.blackAndWhite.white,
        zIndex: 1,
        borderRadius: "4px",
        padding: "4px 10px 4px 8px",
        "&::after": {
            content: '""',
            position: "absolute",
            top: "26px",
            left: "12px",
            borderTop: "6px solid ".concat(theme.palette.text.title),
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderBottom: "0px solid transparent"
        }
    };
});
export default SignUpNextPage;
